<template>
  <div class="d-flex pt-3" style="background: #f8fafb">
    <div class="leftContent">
      <div class="d-flex justify-content-between">
        <div>
          <div class="title">{{ $t('creative.main_img') }}</div>
          <div v-if="mainUrl" class="mainGoodImg">
            <img :src="mainUrl" alt="" />
            <i class="el-icon-delete" style="position: absolute; right: 5px; top: 5px" @click="cancleUploadMain"></i>
          </div>
          <el-upload v-else action="#" accept=".png,.jpg" list-type="picture-card" :auto-upload="false" :show-file-list="false" :on-change="onMainChange">
            <i class="el-icon-upload"></i>
          </el-upload>
        </div>
        <div>
          <div class="title">商品logo</div>
          <div v-if="logoUrl" class="mainGoodImg">
            <img :src="logoUrl" alt="" />
            <i class="el-icon-delete" style="position: absolute; right: 5px; top: 5px" @click="cancleUploadLogo"></i>
          </div>
          <el-upload v-else action="#" accept=".png,.jpg" list-type="picture-card" :auto-upload="false" :show-file-list="false" :on-change="onLogoChange">
            <i class="el-icon-upload"></i>
          </el-upload>
        </div>
      </div>
      <div class="title mt-4">背景描述</div>
      <div class="mt-2" style="position: relative">
        <el-input
          v-if="percentage.prompt == 0"
          class="prompt-input"
          type="textarea"
          v-model="description"
          resize="none"
          :autosize="{ minRows: 8, maxRows: 8 }"
          placeholder="画面描述以短句、短语为佳，建议40个字以上；风格对图像生成有修饰作用。"
          maxlength="1000"
        >
        </el-input>
        <div v-else style="height: 178px; background: #f6f7f9; border-radius: 4px; overflow: hidden; text-align: center">
          <el-progress :stroke-width="10" :percentage="percentage.prompt" :format="format" style="margin-top: 100px"></el-progress>
        </div>
        <el-button type="text" class="writeBtn" @click="generate_prompt"><i class="el-icon-edit"></i>AI一键修饰</el-button>
      </div>
      <!-- 主题风格 -->
      <div class="title mt-4">{{ $t('creative.theme') }}</div>
      <div class="d-flex flex-wrap scenePanel mt-2">
        <div v-for="(item, index) in sceneList" :key="item.key" class="p-1 m-2 sceneItem" :class="` ${index == activeScene ? 'active' : ''}`" @click="changescene(index)">
          <div class="mt-1">{{ $t(item.text) }}</div>
        </div>
      </div>
      <!-- 作图数量 -->
      <div class="title mt-4">{{ $t('creative.quantity') }}</div>
      <div class="mt-2">
        <el-input-number v-model="imgNum" :min="1" :max="9"></el-input-number>
      </div>
      <!-- 画面大小 -->
      <div class="title mt-4">{{ $t('creative.size') }}</div>
      <div class="d-flex flex-wrap justify-content-start mt-2">
        <div :class="`imgSize ${activeImgSize == index ? 'active' : ''}`" v-for="(item, index) in imgSizeList" :key="index" @click="activeImgSize = index">
          <img :src="item" alt="" />
        </div>
      </div>
      <div class="bottomBtn pt-3">
        <el-button style="width: 100%" type="primary" @click="createImg" :loading="wsLoading">{{ $t('creative.generate') }}</el-button>
      </div>
    </div>
    <div class="rightContent px-5 py-3" :key="Date.now()">
      <div class="imagePreview d-flex justify-content-center align-items-center">
        <div :class="['rightNoData', locale]" v-if="!imgAry.length"></div>
        <el-progress v-else-if="percentage.image" :text-inside="true" :stroke-width="20" :percentage="+percentage.image.toFixed(1)" style="width: 500px"></el-progress>
        <div v-else class="processImg">
          <div v-if="[null, undefined, ''].includes(selectedPreviewImg)" class="previewContent">
            <div v-for="item in imgAry" :key="item" class="previewItem" :style="`background-image: url(${item})`">
              <!-- <img :src="item" alt="" /> -->
            </div>
          </div>
          <div v-else style="position: relative; text-align: center">
            <img :src="editImgUrl" alt="" />
            <div v-if="uploadImgUrl" :style="goodsPosition">
              <img :src="uploadImgUrl" alt="" style="max-width: 70%" />
            </div>
            <div v-if="uploadLogourl" :style="logoPosition">
              <img :src="uploadLogourl" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="previewImg mt-3" v-if="!rightNodata">
        <el-carousel indicator-position="outside" :autoplay="false" :loop="false">
          <el-carousel-item v-for="item in previewImgNum" :key="item">
            <div class="d-flex justify-content-start flex-wrap">
              <div
                v-for="(ite, ind) in finalList.slice(...previewImgIndex.get(item - 1))"
                :key="ind"
                :class="`previewImgList ${selectedPreviewImg == ind ? 'active' : ''}`"
                @click="selectedToEdit(ite, ind, true)"
              >
                <img :src="ite" />
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import kele1 from './images/kele1.jpg';
import kele2 from './images/kele2.jpg';
import kele3 from './images/kele3.jpg';
import kele4 from './images/kele4.jpg';
import niunai1 from './images/niunai1.jpg';
import niunai2 from './images/niunai2.jpg';
import niunai3 from './images/niunai3.jpg';
import niunai4 from './images/niunai4.jpg';
import niunai5 from './images/niunai5.jpg';
import niunai6 from './images/niunai6.jpg';
const previewImg = {
  kele: [kele1, kele2, kele3, kele4],
  niunai: [niunai1, niunai2, niunai3, niunai4, niunai5, niunai6],
};
// import { getBase64 } from '@/utils';
import { imgSizeList_zh, imgSizeList_en } from './config';
export default {
  data() {
    return {
      description: '', //背景描述
      imgNum: '', //生成的图片数量
      imgAry: [], //过程图的list
      finalList: [], //最终图的list
      activeImgSize: undefined, //图片尺寸
      canvas: {},
      rightNodata: true, //无预览图
      selectedPreviewImg: undefined, //选中的生成预览图index
      uploadImgUrl: '', //本地上传的商品图片
      uploadLogourl: '', //上传的logo
      word: {
        fontFamily: '',
        fill: '',
        charSpacing: 0,
        fontSize: 0,
        opacity: 1,
      },
      editImgUrl: '', //选中的图
      goodsPosition: '', //预览页的商品位置信息
      logoPosition: '', //预览页logo的位置信息
      wsLoading: false, //websocket通信状态
      sceneList: [
        {
          id: '1',
          text: '通用风格',
        },
        {
          id: '2',
          text: '电商风格',
        },
        {
          id: '3',
          text: '赛博朋克',
        },
        {
          id: '4',
          text: '中国风',
        },
        {
          id: '5',
          text: '写实风格',
        },
        {
          id: '6',
          text: '水墨画',
        },
        {
          id: '7',
          text: '艺术插花',
        },
        {
          id: '8',
          text: '漫画风格',
        },
      ],
      activeScene: undefined,
      mainUrl: '', //主图
      mainFile: [],
      logoUrl: '', //logo
      logoFile: [],
      percentage: {
        prompt: 0,
        image: 0,
      },
      picType: '',
      pagesize: 5,
      locale: 'zh',
    };
  },
  computed: {
    imgSizeList() {
      return this.locale == 'zh' ? imgSizeList_zh : imgSizeList_en;
    },
    //生成图走马灯的页数
    previewImgNum() {
      return this.finalList.length > this.pagesize ? Math.ceil(this.finalList.length / this.pagesize) : 1;
    },
    //生成图走马灯截取的index
    previewImgIndex() {
      const sliceIndexMap = new Map();
      if (this.previewImgNum == 1) return sliceIndexMap.set(0, [0, this.pagesize]);
      for (let i = 0; i < this.previewImgNum; i++) {
        sliceIndexMap.set(i, [this.pagesize * i, this.pagesize * (i + 1)]);
      }
      return sliceIndexMap;
    },
  },
  watch: {
    word: {
      handler(val) {
        let obj = this.canvas.getActiveObject();
        obj && obj.set({ ...val });
        this.canvas.renderAll();
      },
      deep: true,
    },
  },
  methods: {
    format(percentage) {
      return `智能魔法生成中。。。${percentage}%`;
    },
    generate_prompt() {
      if (!this.description) return;
      this.startAnimation('prompt');
      if (/北极熊|可乐/.test(this.description)) {
        this.picType = 'kele';
        this.description =
          '背景:冰山顶部漂浮着一瓶可口可乐，而一只穿着宇航服的北极熊站在冰山上，周围是一种虚无缥缈的幻觉。一个神秘的奇幻世界，充满未知的异域景观和奇异的生物。一个神秘错觉的特写，展示了一个美妙的场景，图像关键词:幻想的视觉效果，虚幻的效果和精致的细节';
      } else if (/牛奶/.test(this.description)) {
        this.picType = 'niunai';
        this.description = '一小瓶牛奶(左下角1.5)，一片布满五彩花朵的草地，宏观，近景，超广角，俯视图，明亮的亮点，日漫卡通场景，场景合成，整体呈现卡通风格，草坪场景，虚幻引擎5游戏纹理';
      }
    },
    startAnimation(key, callback) {
      if (this.percentage[key] < 100) {
        this.percentage[key] += key == 'prompt' ? 1 : 0.2;
        this.animation = window.requestAnimationFrame(this.startAnimation.bind(this, key, callback));
      } else {
        this.percentage[key] = 0;
        callback && callback();
      }
    },
    /**
     * 上传主图
     */
    onMainChange(file) {
      let { name, size } = file || {};
      name = name.toLowerCase();
      if (!name.endsWith('.png') && !name.endsWith('.jpg')) {
        this.$message.warning('仅支持png、jpg格式');
        return false;
      }
      if (size > 10 * 1024 * 1024) {
        this.$message.error('最大支持10M');
        return false;
      }
      this.mainFile = [file];
      this.mainUrl = URL.createObjectURL(file.raw);
    },
    /**
     * 上传logo
     */
    onLogoChange(file) {
      let { name, size } = file || {};
      name = name.toLowerCase();
      if (!name.endsWith('.png') && !name.endsWith('.jpg')) {
        this.$message.warning('仅支持png、jpg格式');
        return false;
      }
      if (size > 10 * 1024 * 1024) {
        this.$message.error('最大支持10M');
        return false;
      }
      this.logoFile = [file];
      this.logoUrl = URL.createObjectURL(file.raw);
    },
    /**
     * 取消上传logo
     */
    cancleUploadMain() {
      this.mainFile = [];
      this.mainUrl = '';
    },
    /**
     * 取消上传logo
     */
    cancleUploadLogo() {
      this.logoFile = [];
      this.logoUrl = '';
    },
    // /**
    //  * 鼠标移入
    //  */
    // mouseover() {
    //   if ([null, undefined, ''].includes(this.selectedPreviewImg)) return;
    //   this.showEditBtn = true;
    // },
    // /**
    //  * 鼠标移出
    //  */
    // mouseleave() {
    //   this.showEditBtn = false;
    // },
    /**
     *立即生成
     */
    createImg() {
      if (!this.mainUrl) {
        this.$message.warning('请上传商品主图');
        return;
      }
      if (!this.logoUrl) {
        this.$message.warning('请上传商品logo');
        return;
      }
      if (!this.description) {
        this.$message.warning('请填写背景描述');
        return;
      }
      if ([undefined, null, ''].includes(this.activeImgSize)) {
        this.$message.warning('请选择生成的尺寸');
        return;
      }
      // this.picType = 'kele';
      this.selectedPreviewImg = '';
      this.imgAry = previewImg[this.picType].slice(0, this.imgNum);
      this.startAnimation('image', this.selectedToEdit.bind(this, this.imgAry[0], 0));
    },
    /**
     * 选择要编辑的图片
     */
    selectedToEdit(url, index, manual) {
      if (!manual) {
        this.finalList = [].concat(this.imgAry, this.finalList);
      }
      this.rightNodata = false;
      this.selectedPreviewImg = index;
      this.editImgUrl = url;
    },
    /**
     * 选择场景
     */
    changescene(index) {
      this.activeScene = index;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input__prefix {
  transform: scale(2.5);
  left: 20px;
  top: 3px;
}
$lwidth: 400px;
.leftContent {
  width: $lwidth;
  padding: 0px 18px;
  background: #ffffff;
  position: relative;
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
  }
  .mainGoodImg {
    position: relative;
    width: ($lwidth - 50px) / 2;
    height: ($lwidth - 150px) / 2;
    background: #f6f7f9;
    border-radius: 5px;
    margin: 8px 0;
    text-align: center;
    padding: 20px 0;
  }
  ::v-deep {
    .el-upload--picture-card {
      width: ($lwidth - 50px) / 2;
      height: ($lwidth - 150px) / 2;
      margin: 8px 0;
    }
    .prompt-input textarea {
      background: #f6f7f9;
      border: none;
    }
    .el-progress__text {
      font-size: 14px;
      transform: translateY(-40px);
    }
  }
  .writeBtn {
    position: absolute;
    bottom: -6px;
    right: 15px;
  }
  .imgSize {
    width: 22%;
    margin: 5px;
    &.active {
      border: 1px solid #5e75fb;
      border-radius: 5px;
    }
  }
  .bottomBtn {
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: #ececec;
  }
  .scenePanel {
    width: 360px;
    max-height: 410px;
    overflow: auto;
    background: #f6f7f9;
    .sceneItem {
      width: calc(22% - 8px);
      text-align: center;
      border: 2px solid transparent;
      box-sizing: border-box;
      background: #fff;
      font-size: 12px;
      cursor: pointer;
      &.active {
        border: 2px solid #5e75fb;
        border-radius: 4px;
      }
    }
  }
}
.rightContent {
  background-color: #f8fafb;
  width: 100%;
  position: relative;
  .imagePreview {
    width: 840px;
    height: 600px;
    border-radius: 16px 16px 16px 16px;
    border: 1px dashed #707070;
    position: relative;
    .processImg {
      width: 840px;
      height: 600px;
      display: flex;
      justify-content: center;
      padding: 10px;
    }
  }
  .rightNoData {
    width: 504px;
    height: 407px;
    background: url('./images/nodata01.png');
    background-size: 60%;
    background-repeat: no-repeat;
    background-position: center;
    &.en {
      background-image: url('./images/nodata01_en.png');
    }
  }
  .previewContent {
    border-radius: 16px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 5px;
    .previewItem {
      width: 33%;
      height: 30%;
      text-align: center;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  .previewImg {
    width: 860px;
    ::v-deep .el-carousel__container {
      height: 180px;
    }
  }
  .previewImgList {
    width: 16%;
    max-height: 150px;
    margin: 15px;
    padding: 4px;
    text-align: center;
    vertical-align: middle;
    &.active {
      border: 2px solid #5e75fb;
      border-radius: 4px;
    }
  }
  .editContent {
    width: 100%;
    height: 500px;
    border-radius: 16px 16px 16px 16px;
    border: 1px dashed #707070;
    position: relative;
    display: flex;
    justify-content: center;
  }
}
</style>